exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-cell__value[data-v-69ab8df4] {\r\n  text-align: left !important;\n}\r\n", ""]);

// exports
